import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "caption"
}

import { useStore } from 'vuex';
import DetailPage from '@shell/components/Resource/Detail/Page.vue';
import Masthead from '@shell/components/Resource/Detail/Masthead/index.vue';
import { useDefaultMastheadProps } from '@shell/components/Resource/Detail/Masthead/composable';
import ResourceTabs from '@shell/components/form/ResourceTabs/index.vue';
import Tab from '@shell/components/Tabbed/Tab.vue';
import ResourceTable from '@shell/components/ResourceTable.vue';
import { useI18n } from '@shell/composables/useI18n';
import { useMountedPods } from './composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const { t } = useI18n(store);
const pvc = props.value;

const defaultMastheadProps = useDefaultMastheadProps(pvc);
const {
  podSchema, podHeaders, mountedPods, loading
} = useMountedPods(pvc);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DetailPage, null, {
    "top-area": _withCtx(() => [
      _createVNode(Masthead, _normalizeProps(_guardReactiveProps(_unref(defaultMastheadProps))), null, 16)
    ]),
    "bottom-area": _withCtx(() => [
      _createVNode(ResourceTabs, { value: _unref(pvc) }, {
        default: _withCtx(() => [
          (_unref(podSchema))
            ? (_openBlock(), _createBlock(Tab, {
                key: 0,
                name: "mounted-pods",
                label: _unref(t)('persistentVolumeClaim.detail.pods.label'),
                weight: 3
              }, {
                default: _withCtx(() => [
                  (!_unref(loading) && !_unref(mountedPods).length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(t)('persistentVolumeClaim.detail.pods.none')), 1))
                    : (_openBlock(), _createBlock(ResourceTable, {
                        key: 1,
                        rows: _unref(mountedPods),
                        loading: _unref(loading),
                        headers: _unref(podHeaders),
                        "key-field": "id",
                        schema: _unref(podSchema),
                        namespaced: false,
                        groupable: false,
                        search: false,
                        "table-actions": false
                      }, null, 8, ["rows", "loading", "headers", "schema"]))
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})